import { SessionFeedbackPage } from '@/components/feedbacks/session-feedback-page';
import { InfoPageSuspenseBoundary } from '@/components/info-page-suspense-boundary';
import { airServerErrorFrom, axiosErrorFrom } from '@/lib/error-handling';
import { paginationRequestSchema, usePagination } from '@/lib/pagination';
import { validateRouteRole } from '@/lib/routing';
import { parseSessionFeedbackCompoundId } from '@/lib/string-utils';
import { isAirAdmin } from '@airreading/common';
import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/sessions/session-feedbacks/$feedbackId')({
  beforeLoad: validateRouteRole(isAirAdmin),
  component: Page,
  loader: ({ params }) => {
    const feedbackCompoundId = parseSessionFeedbackCompoundId(params.feedbackId);
    if (!feedbackCompoundId.sessionId || !feedbackCompoundId.studentId || !feedbackCompoundId.coachId) {
      throw notFound();
    }

    return {
      feedbackCompoundId,
    };
  },
  validateSearch: paginationRequestSchema,
});

function Page() {
  return (
    <InfoPageSuspenseBoundary
      onError={(e) => {
        const axiosError = axiosErrorFrom(e);
        const airServerError = airServerErrorFrom(e);

        return {
          allowRetry: axiosError?.response?.status !== 404,
          errorHeader: airServerError?.userFacingMessage || 'Failed to load class feedback. Please try again.',
          back: {
            backLink: {
              to: '/sessions/session-feedbacks',
            },
          },
        };
      }}
    >
      <FeedbackDetails />
    </InfoPageSuspenseBoundary>
  );
}

function FeedbackDetails() {
  const { feedbackCompoundId } = Route.useLoaderData();
  const pagination = usePagination(Route.id);
  return <SessionFeedbackPage feedbackCompoundId={feedbackCompoundId} pagination={pagination} showCurrent />;
}
